export interface GooglePredictionType {
    description: string;
    matched_substrings: { offset: number; length: number }[];
    place_id: string;
    reference: string;
    structured_formatting: { main_text_matched_substrings: { offset: number; length: number }[]; secondary_text: string; main_text: string };
    terms: { offset: number; value: string }[];
    types: string[];
}

export interface GPlaceDetails {
    address_components: { types: string[]; short_name: string; long_name: string }[];
    adr_address: string;
    formatted_address: string;
    geometry: { viewport: { southwest: { lng: number; lat: number }; northeast: { lng: number; lat: number } }; location: { lng: number; lat: number } };
    icon: string;
    icon_background_color: string;
    icon_mask_base_uri: string;
    name: string;
    place_id: string;
    reference: string;
    types: string[];
    url: string;
    utc_offset: number;
    vicinity: string;
}

export enum GAutocompleteTypes {
    GEOCODE = "geocode",
    ADDRESS = "address"
}